
import { defineComponent, computed, getCurrentInstance, PropType } from 'vue';
import { AIFeed } from '@/api/ai-feed';

const AIChatMessageIntro = defineComponent({
    components: {},
    props: {
        aiFeed: {
            type: Object as PropType<AIFeed> | undefined,
            default: undefined,
        },
    },

    setup(props) {
        const { proxy } = getCurrentInstance() || {};

        const feed = computed(() => {
            return props.aiFeed;
        });

        const introductionText = computed(() => {
            return `${'\xa0\xa0\xa0\xa0\xa0'} ${proxy?.$root?.$t?.('k_1266277')} ${props.aiFeed?.bot_introduction}`;
        });

        return {
            feed,
            introductionText,
        };
    },
});

export default AIChatMessageIntro;
